export default __webpack_public_path__ + "static/media/flange.107b1f80.png";